import { api } from './api'

export const ordersService = {
  // Создание заказа
  create: async (orderData) => {
    const response = await api.post('/orders/orders/', orderData)
    return response.data
  },

  // Получить заказы пользователя
  getMyOrders: async () => {
    const response = await api.get('/orders/orders/')
    return Array.isArray(response.data) ? response.data : response.data.results || []
  },

  // Получить заказ по ID
  getById: async (id) => {
    const response = await api.get(`/orders/orders/${id}/`)
    return response.data
  },
}
